// extracted by mini-css-extract-plugin
export default {"input_name":"name-input_input_name__28hvV"};